<h1 mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content>
  <p>{{data.message}}</p>
  <form [formGroup]="packageTypeForm">
    <p>
        <mat-form-field appearance="outline">
            <mat-label>Package type</mat-label>
            <input required formControlName="type" type="text" matInput placeholder="Type">
            <mat-error *ngIf="packageTypeForm.get('type')?.invalid">
                Package type is invalid
            </mat-error>
        </mat-form-field>
    </p>
    <p>
        <mat-form-field appearance="outline">
            <mat-label>Code</mat-label>
            <input required formControlName="code" type="text" matInput placeholder="Code">
            <mat-error *ngIf="packageTypeForm.get('code')?.invalid">
                Code is invalid
            </mat-error>
        </mat-form-field>
    </p>
</form>
</div>
<div mat-dialog-actions align="end">
  <button mat-raised-button [mat-dialog-close]="false">Cancel</button>
  <button mat-raised-button  color="primary" (click)="createPackageType()">Create</button>
</div>
